
export const SET_PARAMS = 'SET_PARAMS';
export const setParams = params => ({
  type: SET_PARAMS,
  value: params
});